<template>
    <div id="type_task_index">
        <div style="text-align: center;padding-top: 20px;box-sizing: border-box;margin-top: -80px">
            <el-button-group  style="margin: auto">
                <el-button  :class="isTodo ? 'isInActive' : 'isActive'"
                         @click="clickTab('alerts')">通知消息</el-button>
                <el-button @click="clickTab('todo')"
                           :class="isTodo ? 'isActive' : 'isInActive'"
                           style="">待办事项</el-button>
            </el-button-group>
        </div>


        <el-main style="background: white;height: 100%;overflow: visible;padding: 0">
            <router-view></router-view>
        </el-main>
    </div>

</template>

<script>
    export default {
        name: "index",
        data(){
            return {
                isTodo:true
            }
        },
        methods:{
            clickTab(item){
                if (item === 'alerts'){
                    this.isTodo = false
                    this.$router.push({path:'messageList'})
                } else {
                    this.isTodo = true
                    this.$router.push({path:'taskList'})
                }
            },
        },
        mounted() {
            this.isTodo = this.$router.history.current.fullPath !== '/task/messageList';
        }
    }
</script>

<style scoped>
    #type_task_index{
        background: white;
        min-height: 100%;
        padding-top: 80px;
        box-sizing: border-box;

    }
    #type_task_index .isActive{
        color: #409EFF;
        border-color:#c6e2ff;
        background-color: #ecf5ff;
        width: 154px
    }
    #type_task_index .isInActive{
        width: 154px
    }
</style>



// WEBPACK FOOTER //
// src/pages/task/index.vue